(() => {
  'use strict';
  if (customElements.get('abandoned-items')) return;
  const key = 'njt_cart_history_v3';
  const views = new Set();
  let saved = [];
  let current = new Set();

  function clean(item) {
    if (!item || typeof item !== 'object') return null;
    const id = String(item.variant_id || item.id || '');
    if (!/^\d{1,20}$/.test(id) || typeof item.title !== 'string' || typeof item.url !== 'string') return null;
    try {
      const target = new URL(item.url, location.origin);
      if (target.origin !== location.origin || target.username || target.password) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(target.pathname)) return null;
      const variant = target.searchParams.get('variant');
      target.search = '';
      target.hash = '';
      if (variant && /^\d{1,20}$/.test(variant)) target.searchParams.set('variant', variant);
      let image = '';
      if (typeof item.image === 'string' && item.image) {
        const source = new URL(item.image, location.origin);
        if (source.protocol === 'https:' && !source.username && !source.password &&
            (source.origin === location.origin || source.hostname === 'cdn.shopify.com')) {
          source.searchParams.set('width', '160');
          image = source.href;
        }
      }
      return {id, title: item.title.slice(0, 240), url: target.pathname + target.search, image};
    } catch { return null; }
  }

  try {
    const value = sessionStorage.getItem(key);
    const items = value && value.length < 48000 ? JSON.parse(value) : [];
    if (Array.isArray(items)) saved = items.slice(0, 12).map(clean).filter(Boolean);
  } catch {}

  function accept(items) {
    if (!Array.isArray(items)) return false;
    const records = items.map(clean).filter(Boolean);
    current = new Set(records.map(item => item.id));
    const unique = new Map();
    for (const item of [...records, ...saved]) if (!unique.has(item.id)) unique.set(item.id, item);
    saved = [...unique.values()].slice(0, 12);
    try { sessionStorage.setItem(key, JSON.stringify(saved)); } catch {}
    views.forEach(view => view.render());
    return true;
  }

  class CartHistory extends HTMLElement {
    connectedCallback() {
      views.add(this);
      try {
        if (!accept(JSON.parse(this.dataset.cartItems))) this.hidden = true;
      } catch { this.hidden = true; }
    }

    disconnectedCallback() { views.delete(this); }

    render() {
      const list = this.querySelector('[data-cart-history-list]');
      if (!list) return;
      const fragment = document.createDocumentFragment();
      const items = saved.filter(item => !current.has(item.id)).slice(0, 6);
      for (const item of items) {
        const entry = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          link.append(image);
        }
        const title = document.createElement('span');
        title.className = 'njt-history-title';
        title.textContent = item.title;
        const action = document.createElement('span');
        action.className = 'njt-history-action';
        action.textContent = this.dataset.viewLabel || '';
        link.append(title, action);
        entry.append(link);
        fragment.append(entry);
      }
      list.replaceChildren(fragment);
      this.hidden = items.length === 0;
    }
  }

  customElements.define('abandoned-items', CartHistory);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event?.cartData && Array.isArray(event.cartData.items)) accept(event.cartData.items);
    });
  }
})();
